import { useEffect, useState } from "react";
import ConfirmationPopUp from "../MessageBox/ConfirmationPopUp";
import { useLanguageContext } from "../../Context/LanguageContext";

export default function SelectEntry2({
  item,
  OnSelectChange,

  isAddEquipment,
}) {
  const { localization } = useLanguageContext();
  const [currentValue, setCurrentValue] = useState("");
  const [confirmationPopUpOpen, setConfirmationPopUpOpen] = useState(false);
  const [confirmationPopUpMsg, setConfirmationPopUpMsg] = useState("");
  const [callbackData, setCallbackData] = useState(null);
  const [eventType, setEventType] = useState(null);

  const getBackgroundColor = (item) => {
    let _backgroundcolor = null;

    if (
      item.mandatoryField &&
      (item.value == null ||
        item.value == "" ||
        item.value == "null" ||
        item.value == undefined)
    ) {
      _backgroundcolor = { backgroundColor: "#79cdcd" };
    } else {
      if (
        item.mandatoryField &&
        (item.value !== null ||
          item.value !== "" ||
          item.value !== "null" ||
          item.value !== undefined)
      ) {
        _backgroundcolor = { backgroundColor: "#79cdcd" };
      } else {
        _backgroundcolor = { backgroundColor: "#fff" };
      }
    }
    return _backgroundcolor;
  };

  const backgroundColor = getBackgroundColor(item);
  useEffect(() => {
    setCurrentValue(item.value);
  }, [item]);

  const closePopUpCallback = () => {
    setConfirmationPopUpOpen(false);
    setConfirmationPopUpMsg("");
    setCallbackData(null);
    setEventType(null);
  };
  const confirmationOkCancelCallback = (isConfirmed, eventType, data) => {
    if (isConfirmed) {
      switch (eventType) {
        case "TEST_CERATIOR_CHANGE":
          OnSelectChange(data._value, data.tracker, data.item);
          setCurrentValue(data._value);
          closePopUpCallback();
          break;
        default:
          break;
      }
    } else {
      closePopUpCallback();
    }
  };

  function handleChange(_value, tracker, item) {
    if (
      !isAddEquipment &&
      item.code &&
      (item.code.toLowerCase() === "kost" ||
        item.code.toLowerCase() === "testgroup")
    ) {
      const msg =
        item.code.toLowerCase() === "testgroup"
          ? localization.testGroupChangeAlertMsg +
            localization.genericContinueMsg
          : localization.costCenterChangeAlertMsg +
            localization.genericContinueMsg;
      setConfirmationPopUpOpen(true);
      setConfirmationPopUpMsg(msg);
      setCallbackData({
        _value,
        tracker,
        item,
      });
      setEventType("TEST_CERATIOR_CHANGE");
    } else {
      OnSelectChange(_value, tracker, item);
      setCurrentValue(_value);
    }
  }

  return (
    <>
      <div className="form-group" key={item.standardAttributId}>
        <label className="">
          {item.bezeichnung}
          {item.mandatoryField ? (
            <>
              <span className="requiredCls"></span>
            </>
          ) : (
            <></>
          )}
        </label>
        <select
          onChange={(e) => {
            handleChange(e.target.value, item.tracker, item);
          }}
          value={currentValue || ""}
          className="form-control"
          aria-label={item.bezeichnung + "label"}
          disabled={!item.editbarFeld}
        >
          {item.dropdownValue.map((e, index) => (
            <option key={index} value={e.value}>
              {e.label}
            </option>
          ))}
        </select>
      </div>
      <ConfirmationPopUp
        isOpen={confirmationPopUpOpen}
        okCancelCallback={confirmationOkCancelCallback}
        close={closePopUpCallback}
        title=""
        msg={confirmationPopUpMsg}
        eventType={eventType}
        callbackData={callbackData}
        isCancelShow={true}
      />
    </>
  );
}
